import React, { Component } from "react";
import ApiManager from "../../../managers/ApiManager";
import { showToast, TOAST_TYPE } from "deskera-ui-library";
import sanitizeSVG from '@mattkrick/sanitize-svg';

/*
PROPS
- data
- borderStyle
*/

class Collection extends Component {
  inputOpenFileRef;

  constructor(props) {
    super(props);
    this.inputOpenFileRef = React.createRef();
    this.state = {
      inlineEditing: false,
      selectedImageIndex: 0,
    };
  }
  componentWillUnmount() {
    this.setState({ inlineEditing: false });
  }
  render() {
    return (
      <div
        style={{
          ...this.props.data.style,
          ...this.props.borderStyle,
          borderSpacing: "" + this.props.data.style.cellSpacing + "px 0px",
          maxWidth: "100%",
        }}
        className="collections"
      >
        {this.getCollectionItems(this.props.data.value, this.props.data.style)}
        {this.getImagePicker()}
      </div>
    );
  }

  getCollectionItems(items, style) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getCollectionItem(index, item, style));
    });
    return arr;
  }

  getCollectionItem(index, data, style) {
    return (
      <div
        key={index}
        className="collection-list"
        style={{
          width: style.iconSize,
          margin: style.cellSpacing,
          display: "inline-block",
          wordBreak: "break-word",
          verticalAlign: "top",
        }}
      >
        <img
          src={data.icon}
          alt="Item"
          style={{ width: "100%", borderRadius: style.iconRadius }}
          draggable={false}
          onDoubleClick={() => {
            this.setState({ selectedImageIndex: index });
            this.inputOpenFileRef.current.click();
          }}
        />
        {data.title && (
          <div
            contentEditable={this.state.inlineEditing}
            style={{
              marginTop: 4,
              color: style.titleColor,
              fontSize: style.titleSize,
            }}
            dangerouslySetInnerHTML={{ __html: data.title }}
            onDoubleClick={() => {
              this.setState({ inlineEditing: true });
            }}
            onBlur={(e) => {
              e.preventDefault();
              this.setState({ inlineEditing: false });
              this.props.onTextChange(e.target.innerHTML, index, "title");
            }}
          />
        )}
        {data.description && (
          <div
            contentEditable={this.state.inlineEditing}
            style={{
              marginTop: 4,
              color: style.descriptionColor,
              fontSize: style.descriptionSize,
            }}
            dangerouslySetInnerHTML={{ __html: data.description }}
            onDoubleClick={() => {
              this.setState({ inlineEditing: true });
            }}
            onBlur={(e) => {
              e.preventDefault();
              this.setState({ inlineEditing: false });
              this.props.onTextChange(e.target.innerHTML, index, "description");
            }}
          />
        )}
      </div>
    );
  }

  getImagePicker = () => {
    return (
      <input
        type="file"
        accept="image/*"
        ref={this.inputOpenFileRef}
        style={{ display: "none" }}
        onChange={(e) => {
          this.uploadImageToAWS(e.target.files[0]);
        }}
      />
    );
  };

  async uploadImageToAWS(imageData) {
    const cleanImage = await sanitizeSVG(imageData)
    if (!cleanImage) {
        showToast("Image upload failed,seems like a malicious file. Please try uploading another image.", TOAST_TYPE.FAILURE);
        return;
    }
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.props.onValueChange(url, this.state.selectedImageIndex);
      },
      (err) => {
        showToast("Image upload failed", TOAST_TYPE.FAILURE);
      }
    );
  }
}

export default Collection;
